<template>
  <!--begin::Opportunity Listing-->
  <div>
    <PageHeaderCount
      moduleType="opportunities"
      :dataLoading="dataLoading"
      :statusList="statusList"
      allkey="all_opportunities"
      countkey="opportunity_status_count"
    ></PageHeaderCount>
    <ListingTemplate :customClass="'opportunity-listing'">
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="selectedRows.length > 0">
              <v-col cols="4" class="py-0">
                <h1 class="form-title d-flex margin-auto selected-rows-text">
                  {{ totalSelected }} Selected
                </h1>
              </v-col>
              <v-col cols="8" class="py-0 justify-flex-end d-flex margin-auto">
                <div class="d-flex align-center" dir="ltr">
                  <template v-if="getPermission('opportunities:update')">
                    <v-menu
                      content-class="custom-menu-list"
                      bottom
                      offset-y
                      transition="slide-y-transition"
                      :close-on-click="true"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          depressed
                          :disabled="dataLoading"
                          class="mx-2 custom-grey-border custom-bold-button"
                          color="cyan white--text"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(more, index) in bulkActions"
                          :key="index"
                          link
                          v-on:click="updateBulkAction(more.action)"
                        >
                          <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                            <v-icon class="icon-default-blue">{{
                              more.icon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            class="font-weight-500 font-size-14"
                            >{{ more.title }}</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                  <v-btn
                    depressed
                    :disabled="dataLoading"
                    class="mx-2 custom-grey-border custom-bold-button"
                    color="red lighten-1 white--text"
                    v-on:click="clearSelections"
                  >
                    <v-icon dark left>mdi-close</v-icon>Clear Selections
                  </v-btn>
                </div>
              </v-col>
            </template>
            <template v-else>
              <v-col cols="6" class="py-0 col-md-4 col-lg-4 d-flex">
                <div>
                  <h1
                    class="form-title d-flex margin-auto"
                    style="max-width: 200px"
                  >
                    <v-select
                      :menu-props="{ offsetY: true }"
                      :disabled="dataLoading"
                      :items="statusList"
                      v-model="status"
                      hide-details
                      item-color="cyan"
                      class="pt-0 mt-0 listing-status main-listing-status-filter"
                      item-text="text"
                      item-value="value"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="item.text"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-text="item.description"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-chip
                            :color="item.color"
                            :text-color="item.textcolor"
                          >
                            <template v-if="item.value == 'all'">{{
                              item.all_opportunities
                            }}</template>
                            <template v-else>{{
                              item.opportunity_status_count
                            }}</template>
                          </v-chip>
                        </v-list-item-action>
                      </template>
                    </v-select>
                  </h1>
                </div>
              </v-col>
              <v-col
                cols="6"
                class="py-0 pr-0 justify-flex-end d-flex col-md-8 col-lg-8 opportunity-listing-button-right"
              >
                <template v-if="getPermission('opportunities:create')">
                  <v-btn
                    depressed
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button custom-btn-color white--text"
                    @click="goToCreateOpportunity"
                  >
                    <v-icon dark left>mdi-plus</v-icon> Create
                  </v-btn>
                </template>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-on:click="searchDialog = true"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
                <v-menu
                  max-height="400"
                  max-width="250"
                  left
                  offset-y
                  :close-on-content-click="false"
                  content-class="white-background"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      :disabled="dataLoading"
                      class="mx-2 custom-bold-button btn-tab-hide"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable
                    tag="ul"
                    v-model="defaultColDefs"
                    class="draggable-group"
                    handle=".draggable-drag-icon"
                    v-on:change="updateVisible()"
                  >
                    <template v-for="cols in defaultColDefs">
                      <li
                        class="draggable-group-item"
                        :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                      >
                        <v-checkbox
                          dense
                          v-model="defaultColShow"
                          v-bind:value="cols.field"
                          :label="cols.headerName"
                          :disabled="
                            (Number(cols.fixed) > 0 ? true : false) ||
                            dataLoading
                          "
                          color="cyan"
                          hide-details
                          class="mt-0 mb-0"
                          v-on:change="updateVisible()"
                        ></v-checkbox>
                        <v-icon class="draggable-drag-icon" right color="cyan"
                          >mdi-drag</v-icon
                        >
                      </li>
                    </template>
                  </draggable>
                </v-menu>
              </v-col>
            </template>
          </template>
        </ListingHeader>
        <ListingTable :columnCount="columnLength()">
          <template v-slot:thead>
            <thead>
              <tr>
                <template v-for="cols in customThead">
                  <th
                    v-if="cols.visible"
                    :key="cols.id"
                    class="simple-table-th"
                    :class="{
                      'checkbox-width-limit': cols.checkbox,
                      'pointer-events-none': lodash.isEmpty(rowData),
                    }"
                  >
                    <template
                      v-if="cols.checkbox && Number(cols.checkbox) == 1"
                    >
                      <v-checkbox
                        dense
                        :disabled="dataLoading"
                        v-model="selectedAll"
                        color="cyan"
                        class="hide-margin"
                        hide-details
                      ></v-checkbox>
                    </template>
                    <template v-else>
                      <div
                        v-if="cols.sortable"
                        class="simple-table-text sortable"
                        v-on:click="
                          !dataLoading
                            ? updateSorting({
                                field: cols.field,
                                sort: cols.sort,
                              })
                            : 'javascript:void(0)'
                        "
                      >
                        {{ cols.headerName }}
                      </div>
                      <div v-else class="simple-table-text">
                        {{ cols.headerName }}
                      </div>
                      <template v-if="cols.sort">
                        <v-icon
                          class="simple-table-sort"
                          v-if="cols.sort == 'asc'"
                          small
                          right
                          color="cyan"
                          >mdi-sort-ascending</v-icon
                        >
                        <v-icon
                          class="simple-table-sort"
                          v-if="cols.sort == 'desc'"
                          small
                          right
                          color="cyan"
                          >mdi-sort-descending</v-icon
                        >
                      </template>
                    </template>
                  </th>
                </template>
              </tr>
            </thead>
          </template>
          <template v-slot:tbody>
            <tbody>
              <tr
                v-for="(opportunity, index) in rowData"
                :key="index"
                link
                class="opportunity-listing-row"
              >
                <template v-for="cols in customThead">
                  <td
                    v-if="cols.visible"
                    :key="cols.id"
                    :class="{
                      'simple-table-td': !cols.checkbox,
                      'checkbox-width-limit': cols.checkbox,
                    }"
                    v-on:click="
                      Number(cols.checkbox) == 0
                        ? rowClicked(opportunity)
                        : 'javascript:void(0)'
                    "
                  >
                    <!-- CHECKBOX -->
                    <template
                      v-if="cols.checkbox && Number(cols.checkbox) === 1"
                    >
                      <v-checkbox
                        v-model="selectedRows"
                        :value="opportunity.id"
                        dense
                        hide-details
                        color="cyan"
                      />
                    </template>

                    <!-- BARCODE -->
                    <template v-else-if="cols.field === 'barcode'">
                      <Barcode
                        route="opportunity.detail"
                        :id="opportunity.id"
                        :barcode="opportunity.barcode"
                      />
                    </template>

                    <!-- TITLE -->
                    <template v-else-if="cols.field === 'title'">
                      <v-tooltip
                        top
                        max-width="400"
                        content-class="custom-top-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <p
                            class="m-0 custom-nowrap-ellipsis line-climp-content"
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ opportunity.title || "-" }}
                          </p>
                        </template>

                        <span>{{ opportunity.title || "-" }}</span>
                      </v-tooltip>
                    </template>

                    <!-- SOURCE -->
                    <template v-else-if="cols.field === 'source'">
                      {{ opportunity.source || "-" }}
                    </template>

                    <template v-else-if="cols.field === 'type'">
                      <div>
                        <v-chip
                          outlined
                          small
                          color="blue "
                          label
                          class=""
                          v-if="opportunity.type == 'lead'"
                        >
                          <span class="font-size-16 font-weight-500">
                            Lead
                          </span>
                        </v-chip>
                        <v-chip
                          outlined
                          small
                          color="red "
                          label
                          class=""
                          v-if="opportunity.type == 'customer'"
                        >
                          <span class="font-size-16 font-weight-500">
                            Customer
                          </span>
                        </v-chip>
                      </div>
                    </template>

                    <!-- RELATED ID -->
                    <template v-else-if="cols.field === 'lead_id'">
                      <span
                        v-if="opportunity.lead && opportunity.lead.barcode"
                        v-on:click.stop
                      >
                        <Barcode
                          route="lead.detail"
                          :id="opportunity.lead.id"
                          :barcode="opportunity.lead.barcode"
                          small
                        ></Barcode>
                      </span>
                      <span
                        v-else-if="
                          opportunity.customer && opportunity.customer.barcode
                        "
                        v-on:click.stop
                      >
                        <Barcode
                          route="customer.detail"
                          :id="opportunity.customer.id"
                          :barcode="opportunity.customer.barcode"
                          small
                        ></Barcode>
                      </span>
                      <template v-else>-</template>
                    </template>

                    <!-- OPPORTUNITY TEXT -->
                    <template v-else-if="cols.field === 'opportunity_text'">
                      <template v-if="opportunity.opportunity_text">
                        {{ opportunity.opportunity_text }}
                      </template>
                      <em v-else class="text-muted">no opportunity</em>
                    </template>

                    <!-- CONTACT PERSON -->
                    <template v-else-if="cols.field === 'contact_person'">
                      <div v-if="opportunity.contact_person">
                        <p class="m-0">
                          <b>Name:</b>
                          {{ opportunity.contact_person.display_name || "-" }}
                        </p>

                        <p class="m-0">
                          <b>Email:</b>
                          <template
                            v-if="opportunity.contact_person.primary_email"
                          >
                            {{ opportunity.contact_person.primary_email }}
                          </template>
                          <em v-else class="text-muted">no email</em>
                        </p>
                      </div>

                      <div v-else>
                        <p class="m-0">
                          <em class="text-muted">no contact person</em>
                        </p>
                      </div>
                    </template>

                    <!-- STATUS -->
                    <template v-else-if="cols.field === 'status'">
                      <v-chip
                        class="mt-2"
                        :color="getOpportunityStatus(opportunity).color"
                        text-color="white"
                        small
                        label
                      >
                        {{ getOpportunityStatus(opportunity).text }}
                      </v-chip>
                    </template>

                    <!-- OPPORTUNITY DATE -->
                    <!-- <template v-else-if="cols.field === 'opportunity_date'">
                      {{ opportunity.opportunity_date || "-" }}
                    </template> -->
                    <template v-else-if="cols.field === 'opportunity_date'">
                      <template v-if="opportunity.opportunity_date">
                        {{ opportunity.opportunity_date }}
                      </template>
                      <em v-else class="text-muted">no opportunity date</em>
                    </template>

                    <!-- RATING -->
                    <template v-else-if="cols.field === 'rating'">
                      <v-rating
                        :value="Number(opportunity.rating) || 0"
                        readonly
                        dense
                        size="18"
                        color="orange"
                        background-color="orange lighten-3"
                      ></v-rating>
                    </template>

                    <!-- CREATED TIME -->
                    <template v-else-if="cols.field === 'added_at'">
                      <TableActivity
                        v-if="!lodash.isEmpty(opportunity.added_by)"
                        :data="opportunity"
                      >
                        <template v-slot:first_letters>
                          {{
                            getFirstLetters(opportunity?.added_by?.display_name)
                          }}
                        </template>
                        <template v-slot:display_name>
                          <span class="text-capitalize">{{
                            opportunity.added_by.display_name
                          }}</span>
                        </template>
                        <template v-slot:date_time>
                          <template
                            v-if="getDateCountAll(opportunity.added_at)"
                          >
                            {{
                              opportunity.created_at ||
                              dateTimeHumanize(opportunity.added_at)
                            }}
                          </template>
                          <template v-else>
                            {{ formatDateTime(opportunity.added_at) }}
                          </template>
                        </template>
                      </TableActivity>
                    </template>

                    <!-- UPDATED TIME -->
                    <template v-else-if="cols.field === 'updated_at'">
                      {{ formatDateTime(opportunity.updated_at) }}
                    </template>
                  </td>
                </template>
              </tr>

              <tr v-if="rowData.length === 0">
                <td :colspan="customThead.length" class="text-center py-4">
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  <em class="text-muted">
                    Uhh... There are no opportunities at the moment.
                  </em>
                </td>
              </tr>
            </tbody>
          </template>
        </ListingTable>
        <ListingFooter
          :dataLoading="dataLoading"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="totalRows"
          :currentPage="currentPage"
          :totalPages="totalPages"
        ></ListingFooter>
        <v-navigation-drawer
          v-model="searchDialog"
          app
          bottom
          temporary
          stateless
          right
          :width="600"
          style="z-index: 500"
        >
          <v-card
            text
            elevation="0"
            class="d-flex flex-column h-100 custom-field"
          >
            <!-- Drawer Title -->
            <v-card-title
              class="headline dialog-custom-header text-uppercase custom-border-bottom custom-header-blue-text white-background"
            >
              <span style="font-size: 18px">Filter Opportunity</span>
              <v-spacer></v-spacer>
              <v-btn icon small @click="searchDialog = false">
                <v-icon size="30">mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <!-- Drawer Content -->
            <v-card-text class="flex-grow-1 px-3">
              <perfect-scrollbar
                :options="{ suppressScrollX: true }"
                class="scroll custom-box-top-inner-shado"
                style="height: calc(100vh - 125px); position: relative"
              >
                <v-container fluid class="pt-0 custom-search-filter">
                  <v-row>
                    <v-col md="12">
                      <label
                        class="v-label font-weight-500 font-size-13 text-capitalize"
                        >Date Range</label
                      >
                      <DateRangePicker v-model="dates" placeholder="Date Range">
                      </DateRangePicker>
                      <v-menu
                        v-if="false"
                        v-model="datePicker"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <label
                            class="v-label font-weight-500 font-size-13 text-capitalize"
                            >Date Range</label
                          >
                          <v-text-field
                            dense
                            filled
                            flat
                            placeholder="Dates Range"
                            hide-details
                            solo
                            clearable
                            v-on:click:clear="dates = []"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :value="formattedDate"
                            color="cyan"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="cyan"
                          range
                          v-model="dates"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <template v-for="(field, index) in searchableArray">
                      <v-col
                        md="12"
                        :key="index"
                        v-if="field != 'dates' && field != 'opportunity'"
                      >
                        <label
                          class="v-label font-weight-500 font-size-13 text-capitalize"
                        >
                          {{ getFilterLabel(field, "Opportunity") }}
                        </label>

                        <!-- Lead Dropdown -->
                        <template v-if="field === 'lead'">
                          <v-select
                            v-model="listingSearch[field]"
                            :items="leadsList"
                            item-text="text"
                            item-value="value"
                            dense
                            filled
                            hide-details
                            placeholder="Select Lead"
                            solo
                            flat
                            clearable
                            color="cyan"
                          />
                        </template>

                        <!-- Customer Dropdown -->
                        <template v-else-if="field == 'filter_customer'">
                          <v-select
                            v-model="listingSearch['filter_customer']"
                            :items="customersList"
                            item-text="text"
                            item-value="value"
                            dense
                            filled
                            hide-details
                            placeholder="Select Customer"
                            solo
                            flat
                            clearable
                            color="cyan"
                          />
                        </template>

                        <!-- Contact Person Dropdown -->
                        <template v-else-if="field === 'contact_person'">
                          <v-select
                            v-model="listingSearch[field]"
                            :items="contactPersonsList"
                            item-text="text"
                            item-value="value"
                            dense
                            filled
                            hide-details
                            placeholder="Select Contact Person"
                            solo
                            flat
                            clearable
                            color="cyan"
                          />
                        </template>

                        <!-- Default Text Field -->
                        <template v-else>
                          <v-text-field
                            v-model.trim="listingSearch[field]"
                            dense
                            filled
                            hide-details
                            :placeholder="getFilterLabel(field, 'Opportunity')"
                            solo
                            flat
                            clearable
                            @keydown.enter="filterRows"
                            color="cyan"
                          />
                        </template>
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </perfect-scrollbar>
            </v-card-text>

            <!-- Drawer Actions -->
            <v-divider class="my-0"></v-divider>

            <v-card-actions class="d-flex justify-en px-4 pb-4">
              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="red white--text"
                v-on:click="removeFilters('clear')"
              >
                <v-icon left>mdi-close</v-icon>
                <span>Clear Filter</span>
              </v-btn>

              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="cyan white--text"
                @click="filterRows"
              >
                <v-icon left>mdi-magnify</v-icon>
                <span>Apply Filter</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-navigation-drawer>
        <ListingSearchCriteria
          v-if="searchEnabled"
          pageModule="opportunities"
          :basicSearchFields="['barcode', 'opportunity', 'title', 'source']"
          :result="totalRows"
          :allowedSearchFields="searchableArray"
        ></ListingSearchCriteria>
        <Dialog :commonDialog="searchDialog" v-if="false">
          <template v-slot:title>Filter Opportunity</template>
          <template v-slot:body>
            <perfect-scrollbar
              class="scroll"
              style="max-height: 60vh; position: relative"
            >
              <v-container fluid class="pt-0 custom-search-filter">
                <v-row>
                  <v-col md="3" class="py-1">
                    <DateRangePicker
                      v-on:update:date-range="updateDateRange"
                      v-on:update:time-range="updateTimeRange"
                      :defalut-date="dates"
                    ></DateRangePicker>
                  </v-col>
                  <v-col md="3" class="py-1">
                    <v-text-field
                      v-model.trim="listingSearch.barcode"
                      clearable
                      dense
                      filled
                      label="Opportunity #"
                      v-on:click:clear="clearFilter('barcode')"
                      solo
                      flat
                      hide-details
                      color="cyan"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3" class="py-1">
                    <v-text-field
                      v-model.trim="listingSearch.title"
                      clearable
                      dense
                      filled
                      label="Title"
                      v-on:click:clear="clearFilter('title')"
                      solo
                      flat
                      hide-details
                      color="cyan"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3" class="py-1">
                    <v-select
                      v-model.trim="listingSearch.source"
                      clearable
                      :items="sourceList"
                      dense
                      filled
                      label="Source"
                      v-on:click:clear="clearFilter('source')"
                      solo
                      flat
                      item-text="text"
                      item-value="value"
                      hide-details
                      color="cyan"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </perfect-scrollbar>
          </template>
          <template v-slot:action>
            <v-btn
              depressed
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="searchDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              depressed
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-on:click="filterRows"
            >
              Filter
            </v-btn>
          </template>
        </Dialog>
      </template>
    </ListingTemplate>
  </div>
  <!--end::Opportunity Listing-->
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import { PATCH, GET } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import DateRangePicker from "@/view/components/DateRangePicker";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SearchEventBus } from "@/core/lib/search.lib";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import draggable from "vuedraggable";

export default {
  name: "opportunities",
  title: "Opportunities",
  mixins: [CommonMixin, ListingMixin],
  data() {
    return {
      pageModule: "opportunity-listing",
      routeAPI: "opportunities",
      routeName: "opportunities",
      routeDetailName: "opportunity.detail",
      status: "all",
      dialogWidth: 250,
      statusList: [],
      customThead: [],
      searchDialog: false,
      sourceList: [{ text: "Lead", value: "lead" }],
      bulkActions: [
        {
          title: "Mark as Accepted",
          action: "Accepted",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Rejected",
          action: "Rejected",
          icon: "mdi-check-all",
        },
      ],
      leadsList: [],
      customersList: [],
      contactPersonsList: [],
    };
  },
  components: {
    TableActivity,
    Barcode,
    ListingTemplate,
    ListingTable,
    ListingHeader,
    ListingFooter,
    DateRangePicker,
    PageHeaderCount,
    ListingSearchCriteria,
    draggable,
  },
  methods: {
    goToCreateOpportunity() {
      this.$router.push({
        name: "admin.opportunity.create",
        query: {
          type: "lead",
        },
      });
    },
    getValue(obj, field) {
      if (!field) return "-";
      return field.split(".").reduce((acc, key) => acc?.[key], obj) ?? "-";
    },
    removeFilters() {
      SearchEventBus.$emit("clear-search", true);
    },
    updateBulkAction(action) {
      this.dataLoading = true;
      this.$store
        .dispatch(PATCH, {
          url: "opportunities/status",
          data: {
            opportunity: this.selectedRows,
            status: action,
          },
        })
        .then(() => {
          this.getRows();
          this.clearSelections();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },

    getOpportunityStatus(opportunity) {
      const status = this.statusList.find(
        (item) =>
          item.value !== "all" &&
          Number(item.status) === Number(opportunity.status)
      );

      return {
        text: status ? status.text : opportunity.status_text || "Unknown",
        color: status ? status.color : "grey",
      };
    },

    selectOpportunity(param) {
      const id = param?.id || param;

      this.$router.push({
        name: "admin.opportunity.detail",
        params: { id },
      });
    },

    getOptions() {
      this.$store
        .dispatch(GET, {
          url: "opportunities/options",
        })
        .then((response) => {
          if (response && response.data) {
            this.leadsList = response.data.leads || [];
            this.customersList = response.data.customers || [];
            this.contactPersonsList = response.data.contact_persons || [];
          }
        })
        .catch((error) => {
          this.logError(error);
        });
    },
  },
  watch: {
    dates: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param.length > 1) {
          this.listingSearch["dates"] = param;
        } else {
          this.listingSearch["dates"] = undefined;
        }
      },
    },
  },
  mounted() {
    this.getOptions();
    this.$root.$on("clearSelection", () => {
      this.selectedRows = [];
    });
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Opportunity",
      },
    ]);
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);

    _this.status = _this.$route.query.status || _this.status;

    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 50;
  },
};
</script>
